import { withTaskContext } from "@twilio/flex-ui";
import TransferButton from "./TransferButton";

export default withTaskContext(TransferButton);
